import { useTranslation } from 'react-i18next';
import {
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Typography,
} from '@material-ui/core';
import Select from '../../../../common/components/UI/Select/ReactSelect'
import React, { useState, useEffect } from 'react';
import './TimeOffRequestCreationStep.scss';

/**
 * @typedef {{ id: number, label: string }} ITimeOffRequestReason
 * @typedef {{ id: number, name: string, reasons: ITimeOffRequestReason[] }} ITimeOffRequestSubtype
 * @param {{
 *  updateStateSubtypeId: (id: number) => void,
 *  updateStateReasonId: (id: number) => void,
 *  timeOffRequestSubtypeIdSelected: number,
 *  timeOffRequestReasonIdSelected: number,
 *  options: ITimeOffRequestReason[],
 *  disabled?: boolean,
 * }} param0 
 */
const TimeOffRequestCreationStep = ({ updateStateSubtypeId, updateStateReasonId, timeOffRequestSubtypeIdSelected, timeOffRequestReasonIdSelected, options, disabled = false }) => {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'employeeSidePanel.torCreationStep' });
    const [selectedSubtypeId, setSelectedSubtypeId] = useState(timeOffRequestSubtypeIdSelected || null);
    const [selectedReasonId, setSelectedReasonId] = useState(timeOffRequestReasonIdSelected || null);
    const [reasons, setReasons] = useState([]);
    const parsedOptions = options.map(x => ({ label: x.name, value: x.id }))
    
    /**
     * @param {number} id 
    */
    const handleSelectSubtype = async (id) => {
        setSelectedSubtypeId(id);
        await updateStateSubtypeId(id);

        const subtype = options.find(x => x.id === id);
        setReasons(subtype.reasons);
        setSelectedReasonId(null);
        updateStateReasonId(null);
    }

    /**
     * @param {number} id 
    */
    const handleRadioClick = (id) => {
        const parsedId = parseInt(id)
        setSelectedReasonId(parsedId);
        updateStateReasonId(parsedId);
    }

    useEffect(() => {
        const subtype = options.find(x => x.id === timeOffRequestSubtypeIdSelected);
        setReasons(subtype?.reasons || []);
    }, [timeOffRequestSubtypeIdSelected])

    return (
        <FormControl fullWidth disabled={disabled}>
            <Select
                labelText={t('selectSubtypeTitle')}
                placeholder={t('selectSubtypePlaceholder')}
                value={parsedOptions.find(x => x.value === selectedSubtypeId)}
                options={parsedOptions}
                onChange={(event, selected) => handleSelectSubtype(selected.value)}
            />
            {reasons && !!reasons.length && (
                <>
                    <Typography className='tor-creation-reasons-title'>{t('selectReason')}</Typography>
                    <RadioGroup value={selectedReasonId} onChange={(e) => handleRadioClick(e.target.value)} className="tor-creation-radio-group">
                        {
                            reasons.map((x) => (
                                <FormControlLabel
                                    value={x.id}
                                    control={<Radio
                                        color="primary"
                                        checked={selectedReasonId === x.id}
                                    />}
                                    className="tor-option"
                                    label={x.label}
                                    key={`${x.label}_${selectedReasonId === x.id}`}
                                />
                            ))
                        }
                    </RadioGroup>
                </>)}
        </FormControl>
    );
}

export default TimeOffRequestCreationStep;